import type { SVGProps } from 'react';

export const ArrowRight = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.6 12.75H5.25a.799.799 0 0 1-.55-.2.798.798 0 0 1-.2-.55.71.71 0 0 1 .2-.525.748.748 0 0 1 .55-.225H16.6l-3.275-3.3a.72.72 0 0 1-.225-.525c0-.2.075-.375.225-.525a.72.72 0 0 1 .525-.225c.2-.017.383.058.55.225l4.475 4.475a.681.681 0 0 1 .175.3c.05.1.075.208.075.325a.882.882 0 0 1-.075.35.701.701 0 0 1-.175.275L14.4 17.1a.748.748 0 0 1-.55.225.72.72 0 0 1-.525-.225.821.821 0 0 1-.25-.525c0-.2.083-.375.25-.525l3.275-3.3Z" />
    </svg>
  );
};
